import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=51c68fac&scoped=true"
import script from "./RadioGroup.vue?vue&type=script&lang=ts"
export * from "./RadioGroup.vue?vue&type=script&lang=ts"
import style0 from "./RadioGroup.vue?vue&type=style&index=0&id=51c68fac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c68fac",
  null
  
)

export default component.exports